import React from 'react';

const SessionExpiredModal = ({ isOpen, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/70 backdrop-blur-sm p-4 animate-in fade-in duration-200">
      <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl max-w-md w-full overflow-hidden border border-gray-100 dark:border-slate-800 animate-in zoom-in-95 duration-200">
        <div className="p-8 text-center">
          {/* Icono de tiempo/candado */}
          <div className="w-16 h-16 bg-amber-100 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 rounded-full flex items-center justify-center mx-auto mb-5 shadow-inner">
            <i className="fas fa-clock-rotate-left text-2xl"></i>
          </div>

          {/* Título y Mensaje */}
          <h2 className="text-xl font-extrabold text-gray-800 dark:text-slate-100 mb-2">
            Sesión Expirada
          </h2>
          <p className="text-sm text-gray-600 dark:text-slate-400 mb-8 leading-relaxed">
            Tu sesión ha caducado por seguridad o inactividad. Por favor, vuelve a iniciar sesión para continuar utilizando la plataforma.
          </p>

          {/* Botón para re-iniciar sesión */}
          <button
            onClick={onConfirm}
            className="w-full bg-cyan-600 hover:bg-cyan-700 text-white font-bold py-3 px-6 rounded-xl transition-all shadow-lg shadow-cyan-100 dark:shadow-none hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center space-x-2 text-sm uppercase tracking-wider"
          >
            <i className="fas fa-right-to-bracket"></i>
            <span>Ir a Iniciar Sesión</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;